import { useQueryClient } from '@tanstack/react-query'
import { Suspense, useCallback, useEffect, useState } from 'react'

import { mapQueries, type TMarkerSearchParams } from '@/entities/map'
import { SearchMap } from '@/features/search-map'
import { BridgeProvider } from '@/shared/lib'

import { RoomList } from './room-list'
import Sidebar from './sidebar'

export const RoomFinder = () => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const queryClient = useQueryClient()

  const getMarkers = useCallback(
    async (params: TMarkerSearchParams) => {
      const markers = await queryClient.fetchQuery({
        ...mapQueries.markerList(params),
      })

      return markers
    },
    [queryClient],
  )

  return (
    <div className="flex h-[calc(100vh-72px)] pt-[50px]">
      <Suspense>
        <Sidebar>
          <RoomList isMounted={isMounted} />
        </Sidebar>
      </Suspense>
      <BridgeProvider>
        <div className="relative h-full w-full flex-1 overflow-hidden">
          <SearchMap getMarkers={getMarkers} />
        </div>
      </BridgeProvider>
    </div>
  )
}
